import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authService, userService } from '~/services';

const initialState = {
    errors: null,
};
Object.freeze(initialState);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setNewTokens: (state, { payload }) => {
            state.access_token = payload.access_token;
            state.refresh_token = payload.refresh_token;
        },
        clearSession: () => initialState,
    },
    extraReducers: (builder) =>
        builder
            .addCase(loginAction.fulfilled, (state, { payload }) => {
                Object.assign(state, payload);
            })
            .addCase(loginAction.rejected, (state, { payload }) => {
                state.errors = payload;
            })
            .addCase(logoutAction.fulfilled, (state, action) => initialState)
            .addCase(logoutAction.rejected, (state, action) => initialState),
});

const loginAction = createAsyncThunk(
    'auth/login',
    async ({ email, password }, { rejectWithValue }) =>
        authService.login({ email, password }).catch(rejectWithValue)
);

const logoutAction = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) =>
    authService.logout().catch(rejectWithValue)
);

const isValidUserSession = createAsyncThunk('auth/validateUserSession', async (_, thunkAPI) => {
    const { access_token } = thunkAPI.getState().auth;

    if (!access_token) {
        return false;
    }

    try {
        await userService.fetchUserInfo();
        return true;
    } catch {
        thunkAPI.dispatch(clearSession());
        return false;
    }
});

const { setNewTokens, clearSession } = authSlice.actions;

export { loginAction, logoutAction, isValidUserSession, setNewTokens, clearSession };

export default persistReducer({ key: 'auth', storage, blacklist: ['errors'] }, authSlice.reducer);
